export const formattedDate = (dateString: string) => {
  const date = new Date(dateString)
  const day = dateOrdinal(date.getDate())
  const month = date.toLocaleString('en-gb', { month: 'long', timeZone: 'UTC' })
  const year = date.getUTCFullYear()
  return `${day} ${month} ${year}`
}

export const formatDate = (dateString: string | undefined | null, locale: string): string | undefined | null => {
  if (dateString === undefined) return undefined
  if (dateString === null) return null

  const date = new Date(dateString)
  return date.toLocaleString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

const dateOrdinal = (d: number): string => {
  return d + (31 == d || 21 == d || 1 == d ? 'st' : 22 == d || 2 == d ? 'nd' : 23 == d || 3 == d ? 'rd' : 'th')
}

type DateInput = string | number | Date | null | undefined

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const toDate = (value: DateInput): Date => {
  if (value === undefined) return new Date()
  if (value === null) return new Date(Number.NaN)
  if (value instanceof Date) return new Date(value)
  const dateOnly = typeof value === 'string' && /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (dateOnly) return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
  return new Date(value)
}

export const formatDisplayDate = (value: DateInput, { weekday = false, year = true } = {}): string => {
  const date = toDate(value)
  if (Number.isNaN(date.getTime())) return 'Invalid date'
  const dayMonth = `${date.getDate()} ${MONTHS[date.getMonth()]}`
  const withYear = year ? `${dayMonth} ${date.getFullYear()}` : dayMonth
  return weekday ? `${WEEKDAYS[date.getDay()]}, ${withYear}` : withYear
}

export const diffInDays = (to: DateInput, from: DateInput): number => {
  const toDateValue = toDate(to)
  const fromDateValue = toDate(from)
  const dstShift = (fromDateValue.getTimezoneOffset() - toDateValue.getTimezoneOffset()) * 60_000
  return Math.trunc((toDateValue.getTime() - fromDateValue.getTime() + dstShift) / 86_400_000)
}
